/**
 * External Dependencies
 */
import 'jquery';

const search = (query) => {
  if (query) window.location.href = `/?s=${query}`;
}

$(() => {
  // Primary navigation
  const navPrimary = $('#nav-primary');

  $('#hamburger-primary').on('click', () => {
    navPrimary.slideToggle(100);
  });

  // Primary navigation search
  const searchNavigationInput = $('#search-navigation-input');

  $('#search-navigation-submit').on('click', () => {
    search(searchNavigationInput.val());
  });

  searchNavigationInput.on('keydown', ev => {
    if (ev.keyCode === 13) search(searchNavigationInput.val());
  })

  // Plan call to actions
  const contactForm = $('#contact-form');

  if (contactForm.length) {
    $('.plan-cta').on('click', ev => {
      ev.preventDefault();
      contactForm[0].scrollIntoView({ behavior: 'smooth' });

      const subjectField = $("#contact-form :input[name='your-subject']");
      const plan = $(ev.target).data('plan');

      if (subjectField && plan) {
        subjectField.val('Enquiry about' + plan);
      }
    });
  }

  // Account menu
  const accountMenu = $('#account-menu');

  if (accountMenu) {
    accountMenu.hide();

    $('#account-avatar').on('click', () => {
      accountMenu.toggle();
    });

    accountMenu.on('click', () => {
      accountMenu.hide();
    })
  }

  // Toolkits
  const toolkits = $('#toolkits');

  if (toolkits) {
    $(document).on('favorites-updated-single', (event, favourites, postId) => {
      toolkits.children(`.postcard-${postId}`).fadeOut(300);

      if (favourites[0] && favourites[0].posts.length === 0) location.reload();
    })

    $(document).on('favorites-cleared', data => {
      location.reload();
    })
  }
});
